import React, { useEffect, useState } from 'react';
import { StyledKeyValueAttribute as KeyValueAttribute } from './styles';
import {
  PopoverMultipleLines,
  PopoverWithContent,
  POSITION,
  VALUE_STYLE,
} from '../types';
import {
  DynamicPopover,
  mapKeyValueStyleToStormKeyValueVariant,
} from '../utils';
import { useAttributionContext } from './AttributionContext';

export const AttributesKeyValue: React.VFC<{
  id: string;
  valueKey: string;
  value: string;
  valueStyle?: VALUE_STYLE;
  valueUrl?: string;
  toolTip?: string;
  tooltipPosition?: POSITION;
  ariaLabel?: string;
}> = ({
  id,
  valueKey,
  value,
  valueStyle,
  valueUrl,
  toolTip,
  tooltipPosition,
  ariaLabel,
}) => {
  const [dynamicDisplayText, setDynamicDisplayText] = useState(value);
  const [dynamicTooltip, setDynamicTooltip] = useState<
    string | PopoverWithContent | PopoverMultipleLines | undefined
  >(toolTip);
  const [dynamicStyle, setDynamicStyle] = useState(valueStyle);
  const { activationToggleData } = useAttributionContext();

  useEffect(() => {
    const updateKeyValueEvent = () => {
      if (!activationToggleData) return;
      const { attachedComponent, activationResponse } = activationToggleData;
      if (id !== attachedComponent) return;
      const { displayText, popoverContent, status } = activationResponse;
      if (displayText) setDynamicDisplayText(displayText);
      if (popoverContent) setDynamicTooltip(popoverContent);
      if (status) setDynamicStyle(status);
    };
    updateKeyValueEvent();
  }, [activationToggleData]);
  useEffect(() => {
    setDynamicDisplayText(value);
  }, [value]);

  useEffect(() => {
    setDynamicStyle(valueStyle);
  }, [valueStyle]);

  useEffect(() => {
    setDynamicTooltip(toolTip);
  }, [toolTip]);

  return (
    <KeyValueAttribute
      id={id}
      keyText={valueKey}
      valueText={dynamicDisplayText}
      variant={mapKeyValueStyleToStormKeyValueVariant(dynamicStyle)}
      valueUrl={valueUrl}
      helptipText={
        !!dynamicTooltip && <DynamicPopover popover={dynamicTooltip} />
      }
      helptipTextPosition={tooltipPosition}
      data-ccx-e2e-id={`aac-attribute-${id}`}
      aria-label={ariaLabel}
    />
  );
};
